(() => {
  // app/scripts/growave-review.js
  document.addEventListener("DOMContentLoaded", () => {
    console.log("== Growave Review Custom CSS ===");
    function injectCss(shadowRoot, css) {
      if (!shadowRoot) return;
      const style = document.createElement("style");
      style.textContent = css;
      shadowRoot.appendChild(style);
      console.log("injectCss style::", style);
    }
    const onSdkReady = () => {
      const el = document.querySelector("#shopify-section-product-template .gw-rv-reviews-slider-widget-placeholder");
      let tries = 0;
      const maxTries = 12;
      const interval = 500;
      const tryInject = () => {
        tries++;
        if (el && el.shadowRoot) {
          injectCss(el.shadowRoot, `
          .gw-rv-main-slider-widget-wrapper .gw-rv-main-slider-widget__title {
            font-size: 15px !important;
            font-weight: 600 !important;
          }
          .gw-rv-main-slider-widget-wrapper .gw-rv-main-slider-widget__subtitle {
            font-size: 14px !important;
            font-weight: 400 !important;
            margin: 0 !important;
          }
          .gw-rv-main-slider-widget-wrapper .gw-rv-slider-item__content {
            text-align: center !important;
          }
          .gw-rv-main-slider-widget-wrapper .gw-rv-slider-item__card {
            max-width: unset !important;
            max-height: unset !important;
            height: 100% !important;
            border: none !important;
            max-width: 244px !important;
          }
          .gw-rv-main-slider-widget-wrapper .gw-rv-slider-item__image-wrapper {
            width: 100% !important;
            height: 100% !important;
          }
          .gw-rv-main-slider-widget-wrapper .gw-image__img {
            width: 100% !important;
            aspect-ratio: 3/4 !important;
            height: auto% !important;
          }
          .gw-rv-main-slider-arrows .gw-btn {
            width: 30px !important;
            height: 30px !important;
          }
          .gw-rv-main-slider-arrows svg {
            width: 18px !important;
            height: 18px !important;
          }
          .gw-rv-main-slider-arrows .gw-rv-main-slider-arrows__arrow {
            background-color: rgba(199, 198, 198, 0.2) !important;
            transition: background-color 0.3s ease !important;
          }
          .gw-rv-main-slider-widget-wrapper .gw-badge--flat {
            color: var(--gw-badge-bg-color) !important;
            padding-top: 6px !important;
          }
          .gw-rv-main-slider-widget-wrapper .gw-badge--flat path {
            stroke: var(--gw-badge-bg-color) !important;
          }
          .gw-rv-main-slider-arrows .gw-rv-main-slider-arrows__arrow:hover {
            background-color: rgba(199, 198, 198, 0.65) !important;
          }
          .gw-rv-main-slider-arrows .gw-rv-main-slider-arrows__arrow--prev {
            left: -32px;
          }
          .gw-rv-main-slider-arrows .gw-rv-main-slider-arrows__arrow--next {
            right: -32px;
          }
        `);
        } else if (tries < maxTries) {
          setTimeout(tryInject, interval);
        } else {
          console.warn("No open shadowRoot found for Growave widget after 6 seconds");
        }
      };
      tryInject();
    };
    if (window.gw && window.gw.sdk) {
      console.log("Growave SDK ready window.gw.sdk::", window.gw.sdk);
      onSdkReady();
    } else {
      document.addEventListener("gwSdkReady", onSdkReady);
    }
  });
})();
